




















































import { Component } from "vue-property-decorator";
import { EventWidgetComponent } from "../EventWidget";
import MagicValidator from "../../../magic/MagicValidator.vue";

@Component({
  name: "IntInputWidget",
  components: { MagicValidator }
})
export default class IntInputWidget
  extends EventWidgetComponent
  implements App.PuttedWidgetComponent
{
  setValue(value: string) {
    this.value = value;
    this.operateHandler();
  }

  changeHandler(value: string) {
    this.operateHandler();
    this.handleEvent(value);
  }
}
